import React from 'react';
import './Services.css';

const Services = () => {
  // Flatten all services into individual cards
  const allServices = [
    { name: "Commercial Services", description: "Professional landscaping solutions for businesses" },
    { name: "Residential Services", description: "Beautiful landscapes for your home" },
    { name: "Landscape Design", description: "Custom landscape design and planning" },
    { name: "Landscape Maintenance", description: "Regular upkeep and maintenance services" },
    { name: "Irrigation Systems", description: "Installation and maintenance of irrigation systems" },
    { name: "Drainage Solutions", description: "Expert water management and drainage solutions" },
    { name: "Mulch Installation", description: "Professional mulch selection and installation" },
    { name: "Stone Installation", description: "Decorative and functional stone placement" },
    { name: "Sod Installation", description: "Fresh sod installation for instant lawns" },
    { name: "Grading Services", description: "Land grading and surface preparation" },
    { name: "Small Tree Services", description: "Pruning and care for small trees" },
    { name: "Palm Tree Services", description: "Specialized palm tree maintenance and care" },
    { name: "Brush Clean-ups", description: "Thorough brush removal and clean-up" },
    { name: "Land Clearing", description: "Professional land clearing services" },
    { name: "Grub Control", description: "Effective grub prevention and treatment to protect your lawn" },
    { name: "Vegetation Control", description: "Professional weed and unwanted vegetation management" }
  ];

  return (
    <section className="services" id="services">
      <div className="container">
        <div className="section-title">
          <h2>Our Services</h2>
          <div className="stars-rating">
            <span className="star">★</span>
            <span className="star">★</span>
            <span className="star">★</span>
            <span className="star">★</span>
            <span className="star">★</span>
          </div>
          <p>25+ Years of Professional Landscaping Excellence</p>
        </div>

        <div className="services-grid">
          {allServices.map((service, index) => (
            <div key={index} className="service-card">
              <h4>{service.name}</h4>
              <p>{service.description}</p>
            </div>
          ))}
        </div>

        <div className="services-note">
          <p>And so much more! Contact us to discuss your specific landscaping needs.</p>
        </div>
      </div>
    </section>
  );
};

export default Services; 